var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.links.length > 0
    ? _c("HorizontalNavBarWithOverflowMenu", {
        attrs: { navigationLinks: _vm.links },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }